<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab lazy>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Genel Bilgiler
        </template>
        <services-service-card />
      </b-tab>
      <b-tab
        lazy
        :disabled="!itemData.id"
      >
        <template #title>
          <feather-icon icon="DollarSignIcon" />
          Fiyatlandırma
        </template>
        <services-prices-card />
      </b-tab>
      <b-tab
        lazy
        :disabled="!itemData.id"
      >
        <template #title>
          <feather-icon icon="FolderIcon" />
          Dokümanlar
        </template>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <services-files-card />
          </b-col>
          <b-col
            v-if="userData.secret_files === '1' && controlSecretFiles"
            cols="12"
            md="12"
          >
            <services-secret-files-card />
          </b-col>
        </b-row>
      </b-tab>
      <b-tab
        :disabled="!itemData.id"
        lazy
      >
        <template #title>
          <feather-icon icon="FolderIcon" />
          Medya Galeri
        </template>
        <media-card />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs, BTab, BRow, BCol,
} from 'bootstrap-vue'
import ServicesServiceCard from '@/views/Services/Components/ServiceCard.vue'
import ServicesPricesCard from '@/views/Services/Components/PricesCard.vue'
import ServicesFilesCard from '@/views/Services/Components/DocumentsCard.vue'
import ServicesSecretFilesCard from '@/views/Services/Components/SecretDocumentsCard.vue'
import MediaCard from '@/views/Services/Components/MediaCard.vue'

export default {
  name: 'ServicesItemForm',
  components: {
    MediaCard,
    ServicesSecretFilesCard,
    ServicesFilesCard,
    ServicesPricesCard,
    ServicesServiceCard,
    BTabs,
    BTab,
    BRow,
    BCol,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['services/dataItem']
    },
    controlSecretFiles() {
      // userData içindeki packageLimits array'inde subject'i SERVICE_SECRET_FILES olan elemanın limit'i 1 ise true, değilse false döndürür
      if (
        this.userData
          && Array.isArray(this.userData.packageLimits)
      ) {
        const found = this.userData.packageLimits.find(
          item => item.subject === 'SERVICES_SECRET_FILES',
        )
        return found && found.limit === 1
      }
      return false
    },
  },
}
</script>
